// Object-driven sidebar panels for the CRM app.
//
// CRM's panels are thin configs: their ROWS and GROUPS both come from providers,
// because CRM gates on its own permission map and resolves its own active row
// ("longest match wins"). See ./providers/crmProviders.tsx for why, and
// ./crm-nav.ts for the link tables themselves.
//
// Panel `id` must match the `panelId` on the matching rail item in ../apps.ts.

import {
  SIDEBAR_SCHEMA_VERSION,
  type PanelConfig,
  type SidebarConfig,
} from '@clarix/shared-types';

/** A CRM panel whose every group is provider-produced. */
const linkPanel = (id: string, title: string, provider: string): PanelConfig => ({
  id,
  title,
  search: { placeholder: `Search ${title.toLowerCase()}...` },
  sections: [],
  sectionsSource: { provider },
});

const operationsPanel = linkPanel('crm-operations', 'Operations', 'crmOperations');
const commissionPanel = linkPanel('crm-commission', 'Commission', 'crmCommission');

/**
 * Master config + the former Settings and Compliance rails, under one entry.
 * Its groups come from the backend master-config catalogue, so they are
 * provider-produced and drop out when empty.
 */
const masterPanel: PanelConfig = {
  id: 'crm-master',
  title: 'Settings',
  search: { placeholder: 'Search settings...' },
  sections: [],
  sectionsSource: { provider: 'crmMaster' },
};

const usersPanel: PanelConfig = {
  id: 'crm-users',
  title: 'Users',
  sections: [
    {
      id: 'users',
      errorText: 'Failed to load',
      rowsSource: { provider: 'crmUsers' },
    },
  ],
};

export const crmSidebar: SidebarConfig = {
  version: SIDEBAR_SCHEMA_VERSION,
  panels: [operationsPanel, commissionPanel, masterPanel, usersPanel],
};
